/**
 * quest 领域的 GameState 分片注册。
 * 由 app/gameStateSlices.ts 清单挂载；字段类型经 declare module 增补到 GameStateSlices。
 */

import { registerGameStateSlice } from '@/IsekaiRPG/modules/runtime/gameStateRegistry';
import { QuestsStateSchema, type QuestsState } from './types/quest';

declare module '@/IsekaiRPG/modules/runtime/gameStateRegistry' {
  interface GameStateSlices {
    quests?: QuestsState;
  }
}

registerGameStateSlice('quests', QuestsStateSchema.optional(), () => ({
  semanticRecords: {},
  semanticOrder: [],
}));
